import { render, staticRenderFns } from "./BirthdayReport.vue?vue&type=template&id=066d40d8&"
import script from "./BirthdayReport.vue?vue&type=script&lang=js&"
export * from "./BirthdayReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports